import { db } from "../../firebase.config";
import { useState, useEffect } from "react";
import {
  collection,
  onSnapshot,
  addDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import "./Walkthroughscro.scss";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

function Walkcros() {
  const [vids, setVids] = useState([]);
  const [form, setForm] = useState({
    name: "",
    vid: "",
    desc: "",
  });

  const [popupActive, setPopupActive] = useState(false);
  const [selectedVid, setSelectedVid] = useState(null);
  const vidsCollectionRef = collection(db, "walkthroughcro");

  useEffect(() => {
    const unsubscribe = onSnapshot(vidsCollectionRef, (snapshot) => {
      const walkthroughs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setVids(walkthroughs);
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.vid || !form.desc) {
      alert("Please fill out all the fields");
      return;
    }

    addDoc(vidsCollectionRef, form);
    setForm({ name: "", vid: "", desc: "" });
    setPopupActive(false);
  };

  const removeFunc = (id) => {
    if (window.confirm("Are you sure you want to delete?")) {
      deleteDoc(doc(db, "walkthroughcro", id));
      if (selectedVid?.id === id) setSelectedVid(null);
    }
  };

  return (
    <>
      <Header />
      <div className="App">
        <div className="modalBackdrop"></div>

        <div className="functions-wrapper">
          {/* Sidebar */}
          <Sidebar>
            <div className="toolbar">
              <button onClick={() => setPopupActive(true)}>Add Walkthrough</button>
            </div>
            {vids.map((vid) => (
              <div
                key={vid.id}
                className={`snippet-preview ${selectedVid?.id === vid.id ? "active" : ""}`}
                onClick={() =>
                  setSelectedVid((prev) => (prev?.id === vid.id ? null : vid))
                }
              >
                {vid.name}
              </div>
            ))}
          </Sidebar>

          {/* Main content */}
          <div className="function-details">
            {selectedVid ? (
              <>
                <h2>{selectedVid.name}</h2>
                <div className="function__container">
                  <h4>Walkthrough</h4>
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedVid.vid }}
                  ></div>
                </div>
                <div className="function__description-cont">
                  <h4>Description</h4>
                  <p
                    className="function__description"
                    dangerouslySetInnerHTML={{ __html: selectedVid.desc }}
                  ></p>
                </div>
                <div className="buttons">
                  <button
                    className="remove"
                    onClick={() => removeFunc(selectedVid.id)}
                  >
                    Remove
                  </button>
                </div>
              </>
            ) : (
              <p>Select a walkthrough to view details</p>
            )}
          </div>
        </div>

        {popupActive && (
          <div className="popup">
            <div className="popup-inner">
              <h2>Add a Walkthrough</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    value={form.name}
                    onChange={(e) =>
                      setForm({ ...form, name: e.target.value })
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Walkthrough</label>
                  <textarea
                    value={form.vid}
                    onChange={(e) =>
                      setForm({ ...form, vid: e.target.value })
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={form.desc}
                    onChange={(e) =>
                      setForm({ ...form, desc: e.target.value })
                    }
                  />
                </div>
                <div className="buttons">
                  <button type="submit">Submit</button>
                  <button
                    type="button"
                    className="remove"
                    onClick={() => setPopupActive(false)}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Walkcros;
